import { Text } from '@rsos/base-components';
import { formatPhoneWithDashes } from '@rsos/utils';

const ToastMessage = ({
  selectedCallerID,
}: {
  selectedCallerID: null | string;
}) => {
  return (
    <Text>
      Event details from{' '}
      <Text fontWeight="bold" inline>
        {formatPhoneWithDashes(selectedCallerID)}
      </Text>{' '}
      were shared to field responders.
    </Text>
  );
};

export default ToastMessage;
